import React, { Component } from 'react'
import { connect } from 'react-redux'
import { pushEvent } from './actions'

const TrackingHOC = (WrappedComponent, options) => {
  class Tracking extends Component {

    track = (category, payload) => {
      this.props.pushEvent(category, payload)
    }

    render() {
      const props = {
        ...this.props,
        track: this.track
      }

      return <WrappedComponent {...props} />
    }
  }

  const mapDispatchToProps = dispatch => ({
    pushEvent: (category, payload) => dispatch(pushEvent(category, payload))
  })

  return connect(null, mapDispatchToProps)(Tracking)
}

export default TrackingHOC



// WEBPACK FOOTER //
// ./src/hocs/TrackingHOC/index.js